import { setSafe } from "../util/storeHelper";
import Icon from "./Icon";
import * as PropTypes from "prop-types";
import * as React from "react";
import { Image } from "react-bootstrap";
import { Portal } from "react-overlays";
function PopoverImage(props) {
    return (React.createElement(Image, { src: props.src, className: "zoomed-image", onClick: props.onClick, style: { top: props.positionTop, left: props.positionLeft } }));
}
class ZoomableImage extends React.Component {
    static contextTypes = {
        menuLayer: PropTypes.object,
    };
    constructor(props) {
        super(props);
        this.state = {
            showOverlay: false,
        };
    }
    render() {
        const { className, container, overlayClass, url } = this.props;
        const { showOverlay } = this.state;
        const classes = ["zoom-backdrop"];
        if (overlayClass !== undefined) {
            classes.push(overlayClass);
        }
        return (React.createElement("div", { className: className },
            url !== undefined ? (React.createElement(Image, { className: "zoomable-image", src: url, onClick: this.toggleOverlay })) : (React.createElement(Icon, { name: "placeholder-image" })),
            showOverlay ? (React.createElement(Portal, { container: container !== undefined ? container : this.context.menuLayer },
                React.createElement("div", { className: classes.join(" ") },
                    React.createElement(PopoverImage, { src: url, onClick: this.toggleOverlay })))) : null,
            this.props.children));
    }
    toggleOverlay = () => {
        this.setState(setSafe(this.state, ["showOverlay"], !this.state.showOverlay));
    };
}
export default ZoomableImage;
